<div class="top-header font-montserrat">
    <div class="header-bar flex justify-between p-4">
        Welcome Crickteams Admin!
        <cricteams-dy-button [class]="btnClass" (click)="logout()" text="LOGOUT"></cricteams-dy-button>
    </div>    
  </div>